import { withBaseComponent } from '../../hoc/withBaseComponent';

const StoryblokSearchCarousel = ({ blok, baseStyles }) => {
  const { general = { items: [] }, extra = { id: '' } } = blok;
};

export default withBaseComponent(StoryblokSearchCarousel);
